import { render } from "./EventDetails.vue?vue&type=template&id=53ffc96b&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"

import "./EventDetails.vue?vue&type=style&index=0&id=53ffc96b&scoped=true&lang=css"

import exportComponent from "/home/circleci/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ffc96b"]])

export default __exports__